module.exports = __webpack_public_path__ + "static/media/geotechinfowebsite.fc58a88b.webp";